import cx from 'classnames'
import { useContext } from 'react'
import { SanityImageFragment } from '@data/sanity/queries/types/image'
import { StringsContext } from '@lib/strings'
import Photo from '@components/photo'
import BaseInternalLink from '@components/link/base-internal-link'

interface DesktopLogoProps {
  logo?: SanityImageFragment
  invertedLogo?: SanityImageFragment
  isObserverVisible: boolean
  isInvertedLogoVisible: boolean
}

const DesktopLogo = ({
  logo,
  invertedLogo,
  isObserverVisible,
  isInvertedLogoVisible,
}: DesktopLogoProps) => {
  const strings = useContext(StringsContext)

  return (
    <div
      className={cx('relative h-[60px] w-[60px] transition-all duration-300', {
        'md:h-[100px] md:w-[100px]': isObserverVisible,
      })}
    >
      {!!logo?.asset && (
        <BaseInternalLink
          href="/"
          aria-label={strings.goHomeLabel}
          className={cx('transition-opacity', {
            'opacity-0 invisible': isInvertedLogoVisible,
          })}
        >
          <Photo
            image={logo}
            width={logo.dimensions.width}
            height={logo.dimensions.height}
            priority
            showPlaceholder={false}
            imageClassName="block absolute top-0 right-0 bottom-0 left-0 m-auto min-w-[100%] max-w-[100%] min-h-[100%] max-h-[100%] w-0 h-0 overflow-hidden"
          />
        </BaseInternalLink>
      )}
      {!!invertedLogo?.asset && (
        <BaseInternalLink
          href="/"
          aria-label={strings.goHomeLabel}
          className={cx('transition-opacity', {
            'opacity-0 invisible': !isInvertedLogoVisible,
          })}
        >
          <Photo
            image={invertedLogo}
            width={invertedLogo.dimensions.width}
            height={invertedLogo.dimensions.height}
            priority
            showPlaceholder={false}
            imageClassName="block absolute top-0 right-0 bottom-0 left-0 m-auto min-w-[100%] max-w-[100%] min-h-[100%] max-h-[100%] w-0 h-0 overflow-hidden"
          />
        </BaseInternalLink>
      )}
    </div>
  )
}

export default DesktopLogo
